import { render, staticRenderFns } from "./SingleUploadButtons.vue?vue&type=template&id=f4b6ab62"
import script from "./SingleUploadButtons.vue?vue&type=script&lang=js"
export * from "./SingleUploadButtons.vue?vue&type=script&lang=js"
import style0 from "./SingleUploadButtons.vue?vue&type=style&index=0&id=f4b6ab62&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports